import {enumRemap} from 'shared/utils';
import {PeriodType} from '../../types';

export function generateTrackDateOption(trackID: number) {
	return `${enumRemap(PeriodType.PreviousSelectedMarkingPeriod, PeriodType)}-${trackID}`;
}
